/*
 * hero-cta-datalayer.js
 * Pushuje event GA4 `hero_cta_click` do window.dataLayer (custom event GTM).
 *
 * Sledzi klikniecia przyciskow CTA w sekcji hero (.neness-hero-actions).
 * Ladowany TYLKO na stronie glownej (warunek w theme.liquid).
 *
 * Decoupled od markupu: delegowany listener na document czyta dane z klikietego <a>:
 *   cta_button_type ← klasa (primary/secondary) — jednoznaczny dyskryminator
 *   cta_text        ← etykieta desktop (.neness-btn-label-desktop); deterministyczna
 *                     niezaleznie od viewportu. NIE textContent calego <a> — sklejalby
 *                     oba spany (desktop+mobile sa oba w DOM, przelaczane CSS).
 *   cta_url         ← href
 *
 * To NIE jest event ecommerce — bez `ecommerce: null`.
 */
(function () {
  'use strict';

  function readText(btn) {
    var desktop = btn.querySelector('.neness-btn-label-desktop');
    if (desktop && desktop.textContent.trim()) return desktop.textContent.trim();
    var mobile = btn.querySelector('.neness-btn-label-mobile');
    if (mobile && mobile.textContent.trim()) return mobile.textContent.trim();
    return '';
  }

  function readButtonType(btn) {
    if (btn.classList.contains('neness-btn-primary')) return 'primary';
    if (btn.classList.contains('neness-btn-secondary')) return 'secondary';
    return '';
  }

  function onClick(e) {
    var target = e.target;
    var btn = target && target.closest
      ? target.closest('.neness-hero-actions .neness-btn')
      : null;
    if (!btn) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'hero_cta_click',
      cta_button_type: readButtonType(btn),
      cta_text: readText(btn),
      cta_url: btn.getAttribute('href') || ''
    });
  }

  document.addEventListener('click', onClick);
})();
